import PlanetScrubsLanding from './PlanetScrubsLanding';

function App() {
  return <PlanetScrubsLanding />;
}

export default App;
